module.exports = __webpack_public_path__ + "img/image (4).ec5a6c87.jpg";